<template>
    <div>
        <div class="SecondTitleRegistration" style="display: flex;justify-content: center;">
            <span>
                {{ $t('registration.counter') }}:{{ this.storeName }}
            </span>
        </div>
        <van-cell-group style="margin-top: 20px">
            <van-form :onChange="saveInfo()">
                <van-field v-model="info.title">
                    <template #input>
                        <van-dropdown-menu>
                            <van-dropdown-item v-model="info.title"
                                :title="titleOption.find(i => i.value == info.title)?.text || $t('registration.formValueTitle')"
                                :options="titleOption">
                            </van-dropdown-item>
                        </van-dropdown-menu>
                    </template>
                </van-field>
                <van-field required v-model="info.firstName" :placeholder="this.$t('registration.formValueFirstName')"
                    :error-message="errMessageFirstName" @blur="validatorFirstName" />
                <van-field required v-model="info.lastName" :placeholder="this.$t('registration.formValueLastName')"
                    :error-message="errMessageLastName" @blur="validatorLastName" @focus="validatorFirstName" />

                <van-field :label="this.$t('registration.formValueDateOfBirth')"
                    :error-message="errMessageBirth">
                    <template #input>
                        <BirthView @change="validatorBirth()" :country="'MY'" :birth="info.birth" :requiredMonth="true"/>
                    </template>
                </van-field>
                <!-- <van-field required :label="this.$t('registration.formValueDateOfBirth')" :error-message="errMessageBirth">
                    <template #input>
                        <van-dropdown-menu>
                            <van-dropdown-item @change="validatorFirstName(); validatorLastName()" v-model="info.birth.day"
                                :title="info.birth.day == '' ? $t('registration.formValueDay') : info.birth.day"
                                :options="dayOption" />
                            <van-dropdown-item @change="validatorFirstName(); validatorLastName()"
                                v-model="info.birth.month"
                                :title="info.birth.month == '' ? $t('registration.formValueMonth') : info.birth.month"
                                :options="monthOption" />
                            <van-dropdown-item @change="validatorFirstName(); validatorLastName()" v-model="info.birth.year"
                                :title="info.birth.year == '' ? $t('registration.formValueYear') : info.birth.year"
                                :options="yearOption" />
                        </van-dropdown-menu>
                    </template>
                </van-field> -->

                <van-field class="age" :label="this.$t('registration.formValueRace')">
                    <template #input>
                        <van-radio-group v-model="info.race" direction="horizontal"
                            @change="validatorFirstName(); validatorLastName(); validatorBirth()">
                            <van-radio name="MALAY">{{ $t('registration.malay') }}</van-radio>
                            <van-radio name="CHINESE">{{ $t('registration.chinese') }}</van-radio>
                            <van-radio name="INDIAN">{{ $t('registration.indian') }}</van-radio>
                            <van-radio name="OTHERS">{{ $t('registration.other') }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <div style="display: flex;align-items: center;">
                    <div style="margin-left:14px">+60</div>
                    <van-field required type="number" style="border-bottom: 1px solid #f5f6f8" maxlength="10"
                        v-model="info.mobile" :placeholder="this.$t('registration.formValueMobileNumber')"
                        :error-message="errMessagePhone"
                        @focus="validatorFirstName(); validatorLastName(); validatorBirth()" @blur="validatorPhone" />
                </div>
                
                <van-field required v-model="info.email" :placeholder="this.$t('registration.formValueMobileEmail')"
                    :error-message="errMessageEmail"
                    @focus="validatorFirstName(); validatorLastName(); validatorBirth(); validatorPhone(); validatorOPhone()"
                    @blur="validatorEmail()" />

                <van-field>
                    <template #input>
                        <van-dropdown-menu>
                            <van-dropdown-item :title="ageGroupOptions.find(i => i.value == info.ageGroup)?.text || $t('registration.ageGroup')" v-model="info.ageGroup" :options="ageGroupOptions" />
                        </van-dropdown-menu>
                    </template>
                </van-field>
                <!-- Subscribe all statement -->
                <div class="second-tips">
                    <div>
                        <input class="agreeCheckBox" type="checkbox" v-model="info.agreeCondition1"
                            @change="clickAgree()" />
                    </div>
                    <div class="agreeStatement" v-html='$t("registration.frontierNewSub1").format(otherBrands,this.brandConfig.myDisplay)'/>
                </div>

                <!-- Statement Under Gender -->
                <div class="second-tips" v-if="brandConfig.termsAndConditions == ''">
                    <div>
                        <input class="agreeCheckBox" type="checkbox" v-model="info.agreeCondition3" />
                    </div>
                    <div class="agreeStatementMandatory" v-html='agreeStatementMandatoryNotLoyalty'/>
                </div>

                <!-- Statement button  -->
                <div v-else>
                    <div class="second-tips">
                        <div>
                            <input class="agreeCheckBox" type="checkbox" v-model="info.agreeCondition3" />
                        </div>
                        <div class="agreeStatementMandatory" v-html='agreeStatementMandatory'/>
                    </div>
                </div>

                <div style="margin-top: 20px">

                    <van-button :disabled="!(info.agreeCondition3)" size="large" round :loading="bload"
                        class="button-submit" @click="submit()">
                        {{ $t("registration.submit") }}
                    </van-button>
                </div>
            </van-form>
        </van-cell-group>
    </div>
</template>

<script>
import {
    Button, Cell, CellGroup, DropdownItem, DropdownMenu,
    Field, Switch, Checkbox, CheckboxGroup, Form, Radio, RadioGroup, DatetimePicker, Popup, Dialog,Toast
} from 'vant';
import { getSession, relateAddOrUpdate } from '@/api/eformApi';
import mixins from "./../mixin/Registration.js";

export default {
    name: "Registration",
    mixins: [mixins],
    components: {
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Form.name]: Form,
        [CellGroup.name]: CellGroup,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Switch.name]: Switch,
        [Cell.name]: Cell,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Field.name]: Field,
        [Dialog.Component.name]: Dialog.Component,
        BirthView: () => import('./../components/BirthView'),
    },
    props: {
    },
    created() {
        this.init()
    },
    data() {
        return {
            show: true,
            firstName: '',
            info: {
                ageGroup: '',
                title: '',
                firstName: '',
                lastName: '',
                birth: {
                    day: '',
                    month: '',
                    year: ''
                },
                mobile: '',
                othmobile: '',
                email: '',
                gender: '',
                age: '',
                race: '',
                // address: '',
                // address2: '',
                // city: '',
                // state: '',
                // postCode: '',
                subscribeAll: false,
                subscribeEmail: false,
                subscribeMessage: false,
                subscribeCall: false,
                subscribePost: false,
                agreeConditions: false,
                agreeSubscribeStatement: false,
                agreeCondition1: false,
                agreeCondition2: false,
                agreeCondition3: false,
                noneUser: this.$route.params.secondTitle,
                myPattern: /^$|^([0-9]{10})+$/,
                languageCode: ''
            },
            dayOption: [
                { text: '01', value: 1 },
                { text: '02', value: 2 },
                { text: '03', value: 3 },
                { text: '04', value: 4 },
                { text: '05', value: 5 },
                { text: '06', value: 6 },
                { text: '07', value: 7 },
                { text: '08', value: 8 },
                { text: '09', value: 9 },
                { text: '10', value: 10 },
                { text: '11', value: 11 },
                { text: '12', value: 12 },
                { text: '13', value: 13 },
                { text: '14', value: 14 },
                { text: '15', value: 15 },
                { text: '16', value: 16 },
                { text: '17', value: 17 },
                { text: '18', value: 18 },
                { text: '19', value: 19 },
                { text: '20', value: 20 },
                { text: '21', value: 21 },
                { text: '22', value: 22 },
                { text: '23', value: 23 },
                { text: '24', value: 24 },
                { text: '25', value: 25 },
                { text: '26', value: 26 },
                { text: '27', value: 27 },
                { text: '28', value: 28 },
                { text: '29', value: 29 },
                { text: '30', value: 30 },
                { text: '31', value: 31 }
            ],
            monthOption: [
                { text: '01', value: 1 },
                { text: '02', value: 2 },
                { text: '03', value: 3 },
                { text: '04', value: 4 },
                { text: '05', value: 5 },
                { text: '06', value: 6 },
                { text: '07', value: 7 },
                { text: '08', value: 8 },
                { text: '09', value: 9 },
                { text: '10', value: 10 },
                { text: '11', value: 11 },
                { text: '12', value: 12 }
            ],
            yearOption: [
            ],
            firstNameParten: /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/,
            errMessageFirstName: '',
            errMessageLastName: '',
            errMessageEmail: '',
            errMessagePhone: '',
            errMessageOphone: '',
            errMessageBirth: '',
            secondTitlehidden: false,
            stateList: [
                { text: 'Johor', value: 'Johor' },
                { text: 'Kedah', value: 'Kedah' },
                { text: 'Kelantan', value: 'Kelantan' },
                { text: 'Melaka', value: 'Melaka' },
                { text: 'Negeri Sembilan', value: 'Negeri Sembilan' },
                { text: 'Pahang', value: 'Pahang' },
                { text: 'Pulau Pinang', value: 'Pulau Pinang' },
                { text: 'Perak', value: 'Perak' },
                { text: 'Perlis', value: 'Perlis' },
                { text: 'Selangor', value: 'Selangor' },
                { text: 'Terengganu', value: 'Terengganu' },
                { text: 'Sabah', value: 'Sabah' },
                { text: 'Sarawak', value: 'Sarawak' },
                { text: 'Wilayah Persekutuan Kuala Lumpur', value: 'Wilayah Persekutuan Kuala Lumpur' },
                { text: 'Wilayah Persekutuan Labuan', value: 'Wilayah Persekutuan Labuan' },
                { text: 'Wilayah Persekutuan Putra Jaya', value: 'Wilayah Persekutuan Putra Jaya' },
            ],
            dropd: '',
            bload: false
        };
    },
    computed: {
        currentLocale() {
            return this.$root.$i18n.locale;
        },
        ageGroupOptions() {
            return [
                { text: '18-25', value: '{"from":18,"to":25}' },
                { text: '26-35', value: '{"from":26,"to":35}' },
                { text: '36-45', value: '{"from":36,"to":45}' },
                { text: '46-55', value: '{"from":46,"to":55}' },
                { text: '56+', value: '{"from":56,"to":99}' },
            ]
        },
        titleOption() {
            return [
                { text: this.$t('registration.ms'), value: 'Ms' },
                { text: this.$t('registration.mrs'), value: 'Mrs.' },
                { text: this.$t('registration.mr'), value: 'Mr.' },
                { text: this.$t('registration.dr'), value: 'Dr.' },
                { text: this.$t('registration.othe'), value: 'OTHER.' }
            ]
        },
        otherBrands() { 
            return `<span><a href="https://www.elcompanies.com/en/our-brands">${this.$t("registration.otherBrands")}</a></span>`;
        },
        privacyPolicy() { 
            return `<span><a href="${this.brandConfig.privacyPolicy}">${this.$t("registration.privacyPolicy")}</a></span>`;
        },
        loyalty() { 
            return `<span><a href="${this.brandConfig.termsAndConditions}">${this.$t("registration.loyalty").format(this.brandConfig.myDisplay)}</a></span>`;
        },
        agreeStatementMandatory(){
            if (this.$root.$i18n.locale == 'my') {
                return `${this.$t("registration.frontierNewSub2").format(this.privacyPolicy,this.brandConfig.myDisplay,this.brandConfig.myDisplay,this.loyalty)}`
            } else {
                return `${this.$t("registration.frontierNewSub2").format(this.brandConfig.myDisplay,this.privacyPolicy,this.brandConfig.myDisplay,this.loyalty)}`
            }
        },
        agreeStatementMandatoryNotLoyalty(){
            if (this.$root.$i18n.locale == 'my') {
                return `${this.$t("registration.statementUnderGenderNew").format(this.privacyPolicy,this.brandConfig.myDisplay)}`
            } else {
                return `${this.$t("registration.statementUnderGenderNew").format(this.brandConfig.myDisplay,this.privacyPolicy)}`
            }
        }
    },
    watch: {
        'info.subscribeCall': function () {
            if (!this.info.subscribeCall) {
                this.info.subscribeAll = false
            }
            if (this.info.subscribeCall && this.info.subscribeEmail && this.info.subscribeMessage && this.info.subscribePost) {
                this.info.subscribeAll = true
            }
        },
        'info.subscribeEmail': function () {
            if (!this.info.subscribeEmail) {
                this.info.subscribeAll = false
            }
            if (this.info.subscribeCall && this.info.subscribeEmail && this.info.subscribeMessage && this.info.subscribePost) {
                this.info.subscribeAll = true
            }
        },
        'info.subscribeMessage': function () {
            if (!this.info.subscribeMessage) {
                this.info.subscribeAll = false
            }
            if (this.info.subscribeCall && this.info.subscribeEmail && this.info.subscribeMessage && this.info.subscribePost) {
                this.info.subscribeAll = true
            }
        },
        'info.subscribePost': function () {
            if (!this.info.subscribePost) {
                this.info.subscribeAll = false
            }
            if (this.info.subscribeCall && this.info.subscribeEmail && this.info.subscribeMessage && this.info.subscribePost) {
                this.info.subscribeAll = true
            }
        },
        '$route': 'init',
    },
    methods: {
        init() {
            if (localStorage.getItem('info')) {
                this.info = JSON.parse(localStorage.getItem('info'))
            }
            this.getYear()
        },
        getYear() {
            this.yearOption = []
            var year = new Date().getFullYear() - 18;
            for (var i = 0; i < 100; i++) {
                this.yearOption.push({ text: (year - i).toString(), value: (year - i) })
            }
        },
        validatorFirstName() {
            if (this.info.firstName == '' || this.info.firstName.trim() == '') {
                this.errMessageFirstName = this.$t('registration.rulerFirstname');
            } else {
                this.errMessageFirstName = ''
            }
        },
        validatorLastName() {
            if (this.info.lastName == '' || this.info.lastName.trim() == '') {
                this.errMessageLastName = this.$t('registration.rulerLastname');
            } else {
                this.errMessageLastName = ''
            }
        },
        validatorPhone() {
            // var num = this.info.mobile.length
            // if(num>=10){
            //     this.info.mobile = this.info.mobile.slice(0,10)
            // }
            if (this.info.mobile == '' || this.info.mobile.trim() == '') {
                this.errMessagePhone = this.$t('registration.mobileAlert');
            } else {
                var mobileF = this.info.mobile.substr(0, 1)
                if (mobileF != '1') {
                    this.errMessagePhone = this.$t('registration.mobileAlert')
                } else {
                    this.errMessagePhone = ''
                }
            }
        },
        validatorOPhone() {
            var num = this.info.othmobile.length
            if (num >= 10) {
                this.info.othmobile = this.info.othmobile.slice(0, 10)
            }
            if (this.info.othmobile != null && this.info.othmobile != '') {
                var othermobileF = this.info.othmobile.substr(0, 1)
                if (othermobileF == '0') {
                    this.errMessageOphone = this.$t('registration.otherMobileAlert')
                }
            }
        },
        validatorEmail() {
            const reg = /^[0-9A-Za-z_]+([-+.][0-9A-Za-z_]+)*@[0-9A-Za-z_]+([-.][0-9A-Za-z_]+)*\.[0-9A-Za-z_]+([-.][0-9A-Za-z_]+)*$/;
            if (!reg.test(this.info.email) || this.info.email == '' || this.info.email.trim() == '') {
                this.errMessageEmail = this.$t('registration.rulerEmail');
                return false;
            } else {
                this.errMessageEmail = '';
                return true;
            }
        },
        // validatorBirth() {
        //     if (this.info.birth.day == '' || this.info.birth.month == '' || this.info.birth.year == '') {
        //         this.errMessageBirth = this.$t('registration.rulerBirth');
        //     } else {
        //         this.errMessageBirth = '';
        //         return true;
        //     }
        // },
        validatorBirth() {
            this.errMessageBirth = '';
            // if (this.info.birth.day == '') {
            //     this.errMessageBirth = this.$t('registration.rulerBirthday4PH');
            //     return false;
            // }
            if (this.info.birth.month == '') {
                this.errMessageBirth = this.$t('registration.rulerBirth');
                return false;
            }
            // if (this.info.birth.year == '') {
            //     this.errMessageBirth = this.$t('registration.rulerBirthYear4PH');
            //     return false;
            // }
            return true;
        },
        submit() {
            console.log(this.info)
            this.validatorFirstName()
            this.validatorLastName()
            this.validatorBirth()
            this.validatorPhone()
            this.validatorEmail()
            if (this.errMessageBirth != '' || this.errMessageEmail != '' || this.errMessageFirstName != '' || this.errMessageLastName != '' || this.errMessagePhone != '') {
                return
            }

            this.bload = true
            if (this.info.ageGroup && this.info.ageGroup != '') {
                const ageGroupObj = JSON.parse(this.info.ageGroup)
                this.info.ageFrom = ageGroupObj.from
                this.info.ageTo = ageGroupObj.to
            }
            getSession({
                ...this.info,
                country: this.$route.params.countryPath,
                brand: this.$route.params.brand,
            }).then(res => {
                if (res.success) {
                    relateAddOrUpdate({
                        ...this.info,
                        storeId: this.storeId,
                        brand: this.$route.params.brand,
                        country: this.$route.params.countryPath,
                        title: this.info.title == '' ? 'OTHER.' : this.info.title,
                        preLanguage: this.$root.$i18n.locale,
                        sessionKey: res.data,
                        txNo: this.txNo
                    }).then(res => {
                        this.bload = false
                        if (res.success) {
                            this.$router.push({
                                name: 'QRcodes',
                                params: {
                                    custId: res.data.frontiersVipNo,
                                    storeId: this.storeId,
                                    lang: this.$route.params.lang,
                                    brand: this.$route.params.brand,
                                    country: this.$route.params.countryPath
                                },
                                query: {
                                    storeId: this.$route.query.storeId,
                                }
                            })
                        } else if (res.data.exist) {
                            if (res.type == "mobile") {
                                Dialog.alert({
                                    message: this.$t('registration.alreadyRP'),
                                    confirmButtonText: this.$t('registration.confirm')
                                })
                            }
                            if (res.type == "email") {
                                Dialog.alert({
                                    message: this.$t('registration.alreadyRE'),
                                    confirmButtonText: this.$t('registration.confirm')
                                })
                            }
                        } else {
                            Toast.fail(this.$t('common.error'))
                        }
                    }).catch(() => {
                        Toast.fail(this.$t('common.error'))
                    });
                } else {
                    Toast.fail(this.$t('common.error'))
                }
            }).catch(() => {
                Toast.fail(this.$t('common.error'))
            });
        },
        saveInfo() {
            localStorage.setItem('info', JSON.stringify(this.info))
        },
        allClick() {
            this.info.subscribeEmail = this.info.subscribeAll
            this.info.subscribeMessage = this.info.subscribeAll
            this.info.subscribeCall = this.info.subscribeAll
            this.info.subscribePost = this.info.subscribeAll
        },
        clickAgree() {
            if (this.info.agreeCondition1 == false && this.info.agreeCondition2 == false) {
                this.info.subscribeAll = false
                this.info.subscribeEmail = false
                this.info.subscribeMessage = false
                this.info.subscribeCall = false
                this.info.subscribePost = false
            }
        }
    }
}
</script>

<style scoped>
* {
    font-family: Helvetica-Regular !important;
}

input.agreeCheckBox {
    transform: scale(1.5);
    margin-top: 33%
}

.agreeStatementMandatory::before {
    padding-right: 2px;
    color: #ee0a24;
    font-size: 14px;
    content: "*";
    z-index: 100;
}

>>>.requiredMonth{
    margin-right: 20px;
}

 .agreeStatementMandatory {
    margin-left: 10px;
}

.agreeStatement {
    margin-left: 10px;
}

.second-tips {
    display: inline-flex;
    font-size: 14px;
    font-family: Helvetica-Regular;
    font-weight: 400;
    margin-top: 20px;
    line-height: 20px;
    width: 100%;
}

.button-submit {
    background: black;
    color: white;
    border-radius: 7px;
    margin-top: 10px;
}

/*下拉框样式*/
>>>.van-dropdown-menu {
    width: 100%;
}

>>>.van-dropdown-menu__title {
    /* position: unset;
        color: #afafaf; */
    font-size: 14px;
    padding-left: 0px;
}

>>>.van-dropdown-menu__item {
    justify-content: left;
}

>>>.van-dropdown-menu__bar {
    height: unset;
    box-shadow: unset;
}

>>>.van-dialog {
    border-radius: 5px;
}

/*>>> .van-popup--top {*/
/*    width: 90%;*/
/*    margin: 0 5%;*/
/*}*/
/*>>> .van-dropdown-item__option {*/
/*    margin-left: 10px;*/
/*}*/
>>>.van-checkbox {
    /* margin-top: -10% */
}
</style>

<style lang="less" scoped>
.age .van-radio--horizontal {
    margin-bottom: 5px !important;
}

/deep/ .item1::before {
    position: absolute;
    left: -4px;
    top: 0px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}

/deep/ .item2::before {
    position: absolute;
    left: 33%;
    top: 0px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}
</style>
